export type OpenAiAdsApp =
  | "marketing"
  | "talent-agency"
  | "brand"
  | "link-in-bio"
  | "creator";

// Pixel IDs: one per data source (app/website). Create new ones in Ads Manager: https://ads.openai.com/settings/conversions
const OPENAI_ADS_PIXEL_IDS: Record<OpenAiAdsApp, string> = {
  marketing: "Fca7mkRUUZLmtC7xYBUSg5",
  "talent-agency": "4aiaAeoFMxbsGTrKaf4TS9",
  brand: "VJZSfJA6P6A5RTDcJ2Etj1",
  "link-in-bio": "GSLYRAQXYACFjdHxTeAnTv",
  creator: "URVnmBZ1oMRrvhB3Bqryu7",
};

export const getOpenAiAdsPixelId = (app: OpenAiAdsApp): string =>
  OPENAI_ADS_PIXEL_IDS[app];
